import * as ExchangeActionTypes from '../../actiontypes/exchange';


import fetchAvailableSuccess from './fetchAvailableSuccess';
import fetchExchangeSuccess from './fetchExchangeSuccess';
import mergeShopData from './mergeShopData';
import updateShopItems from './updateShopItems';
import { IExchangeState, IFetchExchangeResponse } from 'types/exchange';

/**
 * Initial state
 * @type {Object}
 */
const initialState: IExchangeState = {
  activeItem: null,
  activeStore: null,
  description: '',
  isAvailable: true,
  isDialogOpen: false,
  isFetching: false,
  isFetchingAvailable: false,
  data: { shops: [] },
  isFetchingSellItem: false,
  shops: {
    null: {
      id: null,
      name: 'Sell my things',
      items: [],
    },
  },
  title: '',
};

/**
 * Exchange Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
const Exchange = (state = initialState, action: { type: string, payload: any }) => {
  const { payload = {} } = action;

  switch (action.type) {
    case ExchangeActionTypes.FETCH_EXCHANGE_REQUESTED:
      return {
        ...state,
        isFetching: true,
      };

    case ExchangeActionTypes.FETCH_EXCHANGE_FAILURE:
      return {
        ...state,
        isAvailable: false,
        isFetching: false,
      };

    case ExchangeActionTypes.FETCH_EXCHANGE_SUCCESS:
      return fetchExchangeSuccess(state, payload as IFetchExchangeResponse);

    case ExchangeActionTypes.FETCH_AVAILABLE_REQUESTED:
      return {
        ...state,
        isFetchingAvailable: !payload.background,
      };

    case ExchangeActionTypes.FETCH_AVAILABLE_FAILURE:
      return {
        ...state,
        isFetchingAvailable: false,
      };

    case ExchangeActionTypes.FETCH_AVAILABLE_SUCCESS:
      return fetchAvailableSuccess(state, payload);

    case ExchangeActionTypes.SELECT_STORE_REQUESTED:
      return {
        ...state,
        isFetchingAvailable: true,
      };

    case ExchangeActionTypes.SELECT_STORE_FAILURE:
      return {
        ...state,
        isFetchingAvailable: false,
      };

    case ExchangeActionTypes.SELECT_STORE_SUCCESS:
      return {
        ...state,
        activeStore: payload.id,
        isFetchingAvailable: false,
        shops: mergeShopData(state, payload),
      };

    case ExchangeActionTypes.OPEN_BAZAAR_DIALOG:
      return {
        ...state,
        isDialogOpen: true,
        activeItem: payload.item,
      };

    case ExchangeActionTypes.CLOSE_BAZAAR_DIALOG:
      return {
        ...state,
        isDialogOpen: false,
        activeItem: null,
      };

    case ExchangeActionTypes.SELL_ITEMS_REQUESTED:
    case ExchangeActionTypes.BUY_ITEMS_REQUESTED:
      return {
        ...state,
        isFetchingSellItem: true,
      };

    case ExchangeActionTypes.SELL_ITEMS_FAILURE:
    case ExchangeActionTypes.BUY_ITEMS_FAILURE:
      return {
        ...state,
        isFetchingSellItem: false,
      };

    case ExchangeActionTypes.SELL_ITEMS_SUCCESS:
    case ExchangeActionTypes.BUY_ITEMS_SUCCESS:
      return {
        ...state,
        isFetchingSellItem: false,
        shops: updateShopItems(state, payload),
      };

    case ExchangeActionTypes.REJECT_EXCHANGE:
      return {
        ...state,
        successMessage: payload.message,
      };

    default:
      return state;
  }
};

export default Exchange;
